import { BaseInput } from './base-input';

export class IntegerInput extends BaseInput {
  public constructor(data: any) {
    super(data);
  }
}
